import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'grievance_mechanism_channels'

export const dataPointDefinition = {
  retracedId: 'grievance_mechanism_channels',
  name: 'Through which channels can the grievance mechanism be accessed?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'Letterbox',
      text: 'Letterbox',
    },
    {
      key: 'Hotline',
      text: 'Hotline',
    },
    {
      key: 'Online_Portal',
      text: 'Online Portal',
    },
    {
      key: 'External_Advocate',
      text: 'External Advocate',
    },
    {
      key: 'Staff_Mentor',
      text: 'Staff Mentor',
    },
    {
      key: 'Other',
      text: 'Other',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['Letterbox', 'Hotline', 'Online_Portal', 'External_Advocate', 'Staff_Mentor', 'Other'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: 'null',
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'Green Button: 5.1.1 Gap analysis on grievance mechanisms',
    },
  ],
  sortingId: 13295,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
